import { Link } from "react-router-dom";

const friendLinks = [
  { label: "影视资讯", to: "/news" },
  { label: "热门专题", to: "/special" },
  { label: "电影频道", to: "/category/movie" },
  { label: "电视剧频道", to: "/category/tv" },
  { label: "关于我们", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-900 text-primary-100">
      <div className="mx-auto max-w-page px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-film-line text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                555电影网
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-200">
              555电影网是一个专注于最新电影与电视剧资讯、内容介绍和精选推荐的影视娱乐平台。
              我们致力于帮助每一位观众方便快捷地发现心仪的影视作品。
            </p>
            <p className="mt-4 text-xs text-primary-300">
              本站为影视资讯与内容展示平台，不提供真实视频播放与下载服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <span>快速导航</span>
            </h4>
            <ul className="mt-4 space-y-2 text-sm">
              {friendLinks.slice(0, 4).map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-primary-200 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <span>友情链接</span>
            </h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li className="text-primary-200">影视行业观察</li>
              <li className="text-primary-200">剧集口碑榜</li>
              <li className="text-primary-200">影展资讯速递</li>
              <li>
                <Link
                  to="/about"
                  className="text-primary-200 transition-colors hover:text-accent-400"
                >
                  联系我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 555电影网 版权所有 · 仅供演示学习使用</p>
          <p>本站内容均为虚构展示数据，版权归原作者所有</p>
        </div>
      </div>
    </footer>
  );
}